import {createContext, use} from 'react'
import type {useCopilotReviewEffortDecision} from './use-copilot-review-effort-decision'

export const CopilotReviewEffortContext = createContext<ReturnType<typeof useCopilotReviewEffortDecision> | null>(null)

export function useSharedCopilotReviewEffort() {
  return use(CopilotReviewEffortContext)
}
